  /**********************************************************************
// @@@ START COPYRIGHT @@@
//
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/

import { Api } from '@/services/Api'

export default {
  getAllPlant() {
    return Api().get('/api/v2/admin/plants')
  },
  getAllUser() {
    return Api().get('/api/v2/admin/users')
  },
  fetchConfig(component, query) {
    return Api().get(encodeURI(`/api/v2/admin/${component}${query ?  '?'+query : ''}`))
  },
  saveConfig(payload) {
    return Api().post(`/api/v2/admin`, payload)
  },
  updateConfig(payload) {
    return Api().patch(`/api/v2/admin`, payload)
  },
  deleteConfig(component, query) {
    return Api().delete(encodeURI(`/api/v2/admin/${component}${query ?  '?'+query : ''}`))
  }
}